import { CanDeactivateFn } from '@angular/router';

export interface UnsavedChangesAware {
  canDeactivate(): boolean | Promise<boolean>;
}

/**
 * Blocks leaving the Document Builder route while a section has unsaved
 * changes. Delegates the actual decision (and the confirmation dialog) to the
 * component, which already owns the per-section save state.
 */
export const documentBuilderUnsavedChangesGuard: CanDeactivateFn<
  UnsavedChangesAware
> = (component) => component.canDeactivate();
